module.exports = __webpack_public_path__ + "img/olimpiya.d91b0ada.png";